<template>
  <div class="container">
    <div class="goods-container">
      <div class="title">修改商品</div>
      <div style="margin-top: 30px">
        <el-form size="small" ref="form" :model="form" label-width="100px">
          <el-form-item label="商品名称">
            <el-input
              v-model="form.name"
              placeholder="请输入商品名称"
              style="width: 200px"
            ></el-input>
          </el-form-item>

          <el-form-item label="采购单价(单位:元)">
            <el-input
              v-model="form.original_price"
              placeholder="请输入采购单价"
              style="width: 200px"
            ></el-input>
          </el-form-item>

          <el-form-item label="销售单价(单位:元)">
            <el-input
              v-model="form.present_price"
              placeholder="请输入销售单价"
              style="width: 200px"
            ></el-input>
          </el-form-item>

          <el-form-item label="单位">
            <el-input
              v-model="form.unit"
              placeholder="请输入单位"
              style="width: 200px"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit">保存</el-button>
            <el-button @click="Cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { addOrUpdateOtherGoods } from "@/api/educational";

export default {
  name: "editGoods",
  data() {
    return {
      form: {
        id: "",
        name: "",
        original_price: "", //采购单价
        present_price: "", //销售单价
        unit: "", //单位
      },
    };
  },

  mounted() {
    this.form = this.$route.query.good;
  },

  methods: {
    onSubmit() {
      console.log(this.form.name);
      addOrUpdateOtherGoods({
        goodsId: this.form.id,
        name: this.form.name,
        original_price: this.form.original_price,
        present_price: this.form.present_price,
        unit: this.form.unit,
      }).then((res) => {
        console.log("修改商品");
        console.log(res);
        if (res.is_update) {
          this.$message.success("修改成功");
          this.$router.push({
            name: "admin-basic-settings",
            query: {
              activeMenu: "2",
            },
          });
        }
      });
    },

    Cancel() {
      this.$router.push({
        name: "admin-basic-settings",
        query: {
          activeMenu: "2",
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
  min-width: 1000px;
  overflow-y: scroll;
  .goods-container {
    margin: 20px;
    padding: 20px;
    background-color: #ffffff;
    .title {
      font-size: 16px;
      font-weight: bold;
    }
  }
}
</style>
